<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-row>
      <v-col>
        <v-card flat>
          <v-toolbar flat>
            <v-toolbar-title>ルート詳細</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <!-- コード -->
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  コード
                </div>
                <h4>{{ transportRoute.code }}</h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="transportRoute.invisible"
                  label="非表示にする"
                  disabled
                />
              </v-col>
            </v-row>
            <!-- コード -->
            <!-- ルート名 -->
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  ルート名
                </div>
                <h4>{{ transportRoute.name }}</h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="6">
                <div class="overline">
                  運搬ルート表示順
                </div>
                <h4>{{ transportRoute.sort_priority || '-' }}</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /ルート名 -->
            <!-- ルート -->
            <v-row>
              <v-col>
                <h4>ルート</h4>
                <v-card outlined>
                  <v-data-table
                    :headers="tableHeaders"
                    :items="transportRoute.transport_route_sections"
                    disable-sort
                    hide-default-footer
                  >
                    <template v-slot:[`item.trader_name`]="{ item }">
                      <div>{{ item.trader_name }}</div>
                      <small class="text--disabled">{{ item.trader_address }}</small>
                    </template>
                    <template v-slot:[`item.trader_location_name`]="{ item }">
                      <div>{{ item.trader_location_name }}</div>
                      <small class="text--disabled">{{ item.trader_location_address }}</small>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
            <!-- /ルート -->
            <!-- 処分業者会社名／事業場 -->
            <v-row>
              <v-col class="pb-0">
                <h4>
                  処分業者
                </h4>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2">
                <div class="overline">
                  加入者番号
                </div>
                <h4>{{ transportRoute.disposer_subscriber_number }}&nbsp;</h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="4">
                <div class="overline">
                  会社名
                </div>
                <h4>{{ transportRoute.disposer_name }}&nbsp;</h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="6">
                <div class="overline">
                  事業場
                </div>
                <h4>{{ transportRoute.disposer_location_name }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- 処分方法 -->
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  処分方法
                </div>
                <h4>{{ transportRoute.disposal_method_name }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /処分方法 -->
            <!-- 対象品目 -->
            <v-row>
              <v-col cols="12">
                <div class="overline">
                  対象品目
                </div>
                <h4>{{ transportRoute.transport_route_items?.filter(item => !item._destroy).map(item => item.item_name).join(', ') || '-' }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /対象品目 -->
          </v-card-text>
          <v-card-actions>
            <v-btn
              :disabled="!transportRoute.editable"
              color="error"
              @click="deleteButtonClickEvent"
            >
              削除
            </v-btn>
            <v-spacer />
            <v-btn
              @click="cancelButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="editButtonClickEvent"
            >
              編集
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from "../../../../components/Confirm";
import { mapActions } from 'vuex'

export default {
  name: 'DriverTransportRouteShow',
  components: {
    Confirm
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: 'ルート一覧', disabled: false, to: '/driver/masters/transport_routes', exact: true },
        { text: 'ルート詳細', disabled: true, to: '' },
      ],
      tableHeaders:[
        { value: 'section', text: '区間' },
        { value: 'transport_subscriber_number', text: '加入者番号' },
        { value: 'transport_name', text: '収集運搬業者' },
        { value: 'trader_subscriber_number', text: '加入者番号' },
        { value: 'trader_name', text: '運搬先 会社名\r\n住所' },
        { value: 'trader_location_name', text: '事業場名\r\n住所' },
      ],
      transportRoute: {},
    }
  },
  computed: {},
  watch: {},
  created() {
    this.fetchTransportRoute({ id: this.$route.params.id }).then((content) => {
      this.transportRoute = content
    })
  },
  methods: {
    ...mapActions('DriverMasterTransportRoute', {
      fetchTransportRoute: 'show',
      deleteTransportRoute: 'destroy',
    }),
    cancelButtonClickEvent () {
      this.$router.push({name: 'DriverMasterTransportRoutes'})
    },
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteTransportRoute({id: this.transportRoute.id }).then(() =>{
            this.$router.push({name: 'DriverMasterTransportRoutes', params: { resetPagination: true }})
          })
        }
      })
    },
    editButtonClickEvent () {
      this.$router.push({name: 'DriverMasterTransportRouteEdit', params: { id: String(this.transportRoute.id) }})
    }
  }
}
</script>
